var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0577 7.96527L14.611 7.02835L11.7291 1.18597C11.6504 1.02601 11.5209 0.896518 11.361 0.817807C10.9598 0.61976 10.4723 0.784799 10.2717 1.18597L7.38988 7.02835L0.943203 7.96527C0.765468 7.99066 0.602968 8.07445 0.478554 8.2014C0.328144 8.35599 0.245262 8.56398 0.248118 8.77965C0.250975 8.99532 0.339337 9.20104 0.493788 9.3516L5.15805 13.8991L4.05609 20.3203C4.03025 20.4697 4.04678 20.6233 4.10381 20.7638C4.16083 20.9043 4.25607 21.0259 4.37873 21.115C4.50138 21.2041 4.64654 21.257 4.79775 21.2678C4.94896 21.2786 5.10016 21.2468 5.23422 21.176L11.0004 18.1444L16.7666 21.176C16.9241 21.2598 17.1069 21.2877 17.2821 21.2573C17.7239 21.1811 18.0209 20.7621 17.9448 20.3203L16.8428 13.8991L21.5071 9.3516C21.634 9.22718 21.7178 9.06468 21.7432 8.88695C21.8118 8.44261 21.502 8.03128 21.0577 7.96527V7.96527Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.da8dc812fd2e82c1477753b3eca32bfb.svg";
export { ForwardRef as ReactComponent };